(() => {
  if (customElements.get('ys-tdm')) return;

  class YsTdm extends HTMLElement {
    connectedCallback() {
      if (this.onChoice) return;
      this.controls = this.querySelector('[data-ys-tdm-controls]');
      this.buttons = [...this.querySelectorAll('[data-ys-tdm-need]')];
      this.cards = [...this.querySelectorAll('[data-ys-tdm-card]')];
      this.result = this.querySelector('[data-ys-tdm-result]');
      this.resetButton = this.querySelector('[data-ys-tdm-reset]');
      if (!this.controls || !this.result || !this.resetButton || !this.cards.length || !this.buttons.length) return;

      this.defaultMessage = this.result.textContent;
      this.onChoice = (event) => {
        const button = event.target.closest('[data-ys-tdm-need], [data-ys-tdm-reset]');
        if (!button || !this.controls.contains(button)) return;
        const need = button.dataset.ysTdmNeed;
        if (!need || button.getAttribute('aria-pressed') === 'true') {
          const previousChoice = this.buttons.find((item) => item.getAttribute('aria-pressed') === 'true');
          this.clearChoice();
          if (!need && previousChoice) previousChoice.focus();
          return;
        }
        const matches = [];
        this.buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        this.cards.forEach((card) => {
          const matched = card.dataset.ysTdmMatches.trim().split(/\s+/).includes(need);
          card.toggleAttribute('data-ys-tdm-matched', matched);
          const label = card.querySelector('[data-ys-tdm-match]');
          if (label) label.hidden = !matched;
          if (matched) matches.push(card.dataset.ysTdmTitle);
        });
        this.resetButton.disabled = false;
        this.result.textContent = matches.length
          ? `Passende Modelle: ${matches.join(', ')}. ${button.dataset.ysTdmMessage || ''}`
          : 'Kein Modell entspricht dieser Auswahl. Vergleichen Sie die Details unten oder setzen Sie Ihre Auswahl zurück.';
      };
      this.controls.addEventListener('click', this.onChoice);
      this.clearChoice();
      this.controls.hidden = false;
    }

    clearChoice() {
      this.buttons.forEach((button) => button.setAttribute('aria-pressed', 'false'));
      this.cards.forEach((card) => {
        card.removeAttribute('data-ys-tdm-matched');
        const label = card.querySelector('[data-ys-tdm-match]');
        if (label) label.hidden = true;
      });
      this.result.textContent = this.defaultMessage;
      this.resetButton.disabled = true;
    }

    disconnectedCallback() {
      if (!this.onChoice) return;
      this.controls.removeEventListener('click', this.onChoice);
      this.clearChoice();
      this.controls.hidden = true;
      this.onChoice = null;
    }
  }

  customElements.define('ys-tdm', YsTdm);
})();
